module.exports = __webpack_public_path__ + "img/smLogo.c533c21c.svg";